module.exports = __webpack_public_path__ + "static/media/arthur_english_british.7306f988.mp3";